import { useState, useEffect } from "react";
import styles from "./admin-dashboard.module.css";
import MenuLateral from "../../components/AdminPanel/MenuLateral/menu-lateral";
import CreateInsight from "./dashboardPages/CreateInsight/create-insight";
import Usuarios from "./dashboardPages/Usuarios/usuarios";
import SetupPage from "./dashboardPages/Setup/setup";
import { IUser } from "../../interfaces/user";

type Props = {
  onClickLogout: () => void;
};

const AdminDashboard = ({ onClickLogout }: Props) => {
  const [user, setUser] = useState<IUser>({} as IUser);
  const [selected, setSelected] = useState<string>("Insights");

  const onChangeSelected = (selected: string) => {
    if (selected.length > 0) setSelected(selected);
  };

  const getUser = async (token: string) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      if (!apiUrl) {
        console.error("Erro: API URL não definida.");
        return;
      }

      const response = await fetch(`${apiUrl}/users`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const resData = await response.json();

      if (!response.ok) {
        alert(
          `${resData.message} ${resData.details}` || "Erro ao buscar usuário"
        );
        return;
      }

      const userRes = resData.data as IUser;
      setUser({ ...userRes, password: "" });

      return resData.data as IUser;
    } catch (error) {
      alert("Erro ao buscar usuário: " + error);
      setUser({} as IUser);
      return;
    }
  };

  useEffect(() => {
    const getCookie = (name: string) => {
      const match = document.cookie.match(`(^|;)\\s*${name}=([^;]+)`);
      return match ? match[2] : null;
    };

    const token = getCookie("token");
    if (token) {
      getUser(token)
        .then((userData) => {
          if (userData) console.log("Usuário carregado com sucesso.");
        })
        .catch((error) => {
          console.log("Erro ao buscar usuário: " + error);
          setUser({} as IUser);
        });
    }
  }, []);

  return (
    <div className={styles.adminDashboard}>
      <div className={styles.menu}>
        <MenuLateral
          selected={selected}
          onChangeSelected={onChangeSelected}
          onClickLogout={onClickLogout}
        />
      </div>

      <div className={styles.dashboardContent}>
        {selected === "Insights" && (
          <CreateInsight user={user} selected={selected} />
        )}
        {selected === "Usuários" && <Usuarios selected={selected} />}
        {selected === "Configurações" && (
          <SetupPage user={user} selected={selected} getUser={getUser} />
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
